import { useMsal } from '@azure/msal-react';
import { apiScope } from '../auth/msalConfig';

export function useAuth() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  async function getAccessToken(): Promise<string> {
    if (!account) throw new Error('Not authenticated');

    const response = await instance.acquireTokenSilent({
      scopes: [apiScope],
      account,
    });

    return response.accessToken;
  }

  function logout() {
    instance.logoutRedirect();
  }

  return {
    account,
    isAuthenticated: !!account,
    getAccessToken,
    logout,
  };
}
